import moment from "moment";
import formatCurrency from "format-currency";
import _ from "lodash";
import createProjectModal from "../../../common/modals/createProjectModal/createProjectModal.component";

class ProjectsController {
  constructor($rootScope, $http, $state, toastr, AuthenticationService, $uibModal) {
    "ngInject";
    this.name = 'projects';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.projects = [];
    let self = this;
    this.newProjectName = '';
    this.newProjectContract = 'none';
    this.contracts = [];
    this.$state = $state;
    this.toastr = toastr;
    this.auth = AuthenticationService;
    this.selectedProjects = [];
    this.$uibModal = $uibModal;

    this.$http.get($rootScope.apiHost+"/api/admin/contracts", {withCredentials: true}).then(function (success) {
      self.contracts = success.data;
    });

    this.projectFilter = {
      name: '',
      status: 'open'
    }

    this.filterrefresh = false;

    this.projectColumns = [
      {
        displayName: 'Number',
        value: 'number',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return "<a href=\"admin/projects/"+record.id+"\" >"+record.number+"</a>"
        }
      },
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return "<a href=\"admin/projects/"+record.id+"\" >"+record.name+"</a>"
        }
      },
      {
        displayName: 'Contract',
        value: 'contract',
        sortable: true,
        sortValue: 'contract',
        dataType: 'text',
        formatting: function (record) {
          const contractLink = "<a href=\"admin/contracts/"+record.contractId+"\" >"+record.contract+"</a>";
          const customerShortName = record.customerShortName || '';
          if (customerShortName) {
            return contractLink + " (" + customerShortName + ")";
          }
          return contractLink;
        }
      },
      {
        displayName: 'Start Date',
        value: 'startDate',
        sortable: true,
        sortValue: 'startDate',
        dataType: 'date',
        formatting: function (record) {
          return moment(record.startDate).format("MMM, DD, YYYY")
        }
      },
      {
        displayName: 'Completion Date',
        value: 'completionDate',
        sortable: true,
        sortValue: 'completionDate',
        dataType: 'date',
        formatting: function (record) {
          let completionDate = null;
          let formattedDate = '';
          
          if (record.completionDate) {
            completionDate = moment(record.completionDate);
            formattedDate = completionDate.format("MMM, DD, YYYY");
          } else {
            return '(Not Set)';
          }

          // Check if completion date is expired (before today) and project is not closed
          let dateHtml = formattedDate;
          if (record.completionDate && !record.closed) {
            const completionDateDirect = moment(record.completionDate).startOf('day');
            const today = moment().startOf('day');
            if (completionDateDirect.isBefore(today)) {
              dateHtml = '<span class="expired-project-cell"><i class="fa fa-exclamation-triangle" style="color: #dc3545; margin-right: 5px;"></i>' + formattedDate + '</span>';
            }
          }
          
          // Add ATP information if project has an ATP date
          if (record.atpDate) {
            const atpDateFormatted = moment(record.atpDate).format("MMM, DD, YYYY");
            dateHtml += '<br><span style="font-size: 0.9em; color: #666; font-style: italic;">The project is under ATP until ' + atpDateFormatted + '.</span>';
          }
          
          return dateHtml;
        }
      },
      {
        displayName: 'Funding',
        value: 'funding',
        secure: this.auth.hasPermission('PERM_VIEW_PROJECT_FUNDING'),
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return '$'+formatCurrency(record.funding);
        }
      },
      {
        displayName: 'Revenue',
        value: 'allTimeRevenue',
        sortable: true,
        secure: this.auth.hasPermission('PERM_VIEW_PROJECT_REVENUE_INFORMATION'),
        dataType: 'text',
        formatting: function (record) {
          return '$'+formatCurrency(record.allTimeRevenue);
        }
      },
      {
        displayName: 'YTD Revenue',
        value: 'yearlyRevenue',
        sortable: true,
        sortValue: 'ytdRevenue',
        secure: this.auth.hasPermission('PERM_VIEW_PROJECT_REVENUE_INFORMATION'),
        dataType: 'text',
        formatting: function (record) {
          return '$'+formatCurrency(record.yearlyRevenue);
        }
      },
      {
        displayName: 'Remaining Funding',
        value: 'remainingFunding',
        sortable: true,
        secure: this.auth.hasPermission('PERM_VIEW_PROJECT_REVENUE_INFORMATION'),
        dataType: 'text',
        formatting: function (record) {
          const remainingFunding = parseFloat(record.remainingFunding) || 0;
          const formattedValue = '$'+formatCurrency(record.remainingFunding);
          if (remainingFunding < 0) {
            return '<span class="negative-funding-cell"><i class="fa fa-exclamation-triangle" style="color: #dc3545; margin-right: 5px;"></i>' + formattedValue + '</span>';
          }
          return formattedValue;
        }
      }
    ];

    this.filterCriteria = function () {
      return "status="+self.projectFilter.status+"&name="+self.projectFilter.name;
    }


  }



  filterProjects() {
    this.filterrefresh = true;
  }



  formatDate(date) {
    if(date) {
      return moment(date).format("MMM DD, YYYY");
    }

    return '(Not Set)'
  }

  currency(value) {
    let formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    return formatter.format(value);
  }

  testSort(value) {
    console.log('calling all cars');
  }


  createProject() {
    const modalInstance = this.$uibModal.open({
      template: createProjectModal.template,
      controller: createProjectModal.controller,
      controllerAs: '$ctrl',
      size: 'lg',
      windowClass: "hmodal-info animated zoomIn",
      resolve: {
        resolvedContractId: () => null, // No pre-selected contract from projects page
        resolvedContracts: () => this.contracts || []
      }
    });

    modalInstance.result.then((project) => {
      this.toastr.success("Your Project Was Created Successfully!", "Project Created");
      this.$state.go("admin.project-details", {'projectId': project.id});
    }).catch(() => {
      // Modal dismissed
    });
  }

  activeProjectCount(){
    let cnt = 0;
    this.projects.forEach(function (proj){
      if(!proj.closed){
        cnt++;
      }
    });

    return cnt;
  }

  closedProjectCount(){
    let cnt = 0;
    this.projects.forEach(function (proj){
      if(proj.closed){
        cnt++;
      }
    });

    return cnt;
  }

  getProjects() {
    let filteredProjects = [];
    let self = this;
    this.projects.forEach(function (proj) {

      if (self.showInactiveProjects && proj.closed) {
        filteredProjects.push(proj);
      } else if(!proj.closed) {
        filteredProjects.push(proj);
      }
    });

    return filteredProjects;
  }

  filterProject(project) {
    if(this.showInactiveProjects && project.closed) {
      return false;
    }

    // if(moment(project.completionDate).isBefore(moment())){
    //   return false;
    // }

    return project.closed;
  }
}

export default ProjectsController;



// WEBPACK FOOTER //
// ./client/pages/admin/projects/projects.controller.js